import { createAppReducerSimpleFetch } from "shared/redux-store/defaults";
import { defaultInitialState } from "shared/redux-store/defaultAppReducerParts";
import { normalizeApi } from "shared/api";
import reduceReducers from "reduce-reducers";

// please generalize when implementing the next remove action
function submitRemoveReceiveSuccessState(state, action) {
  const deletedOrderUnit = normalizeApi(action.payload[0].data, "orderUnit");
  const oldOrderUnitIds = (state.currentPageData || {}).orderUnits;
  const newOrderUnitIds = (oldOrderUnitIds || []).filter(
    orderUnitId => orderUnitId !== deletedOrderUnit.id,
  );
  return {
    isFetching: false,
    currentPageData: { ...state.currentPageData, orderUnits: newOrderUnitIds },
  };
}

const orderUnitsOverviewAppReducerFetch = createAppReducerSimpleFetch(
  "ORDER_UNITS_OVERVIEW",
  ["orderUnits", "products"],
);

function orderUnitsOverviewAppReducerSubmit(
  state = defaultInitialState(),
  action,
) {
  switch (action.type) {
    case "SUBMIT_ORDER_UNIT_REMOVE_FULFILLED":
      return {
        ...state,
        ...submitRemoveReceiveSuccessState(state, action),
        submitSuccessMessage: "Bestelleinheit wurde erfolgreich gelöscht",
      };
    case "SUBMIT_ORDER_UNIT_REMOVE_REJECTED":
      return {
        ...state,
        isSubmitting: false,
        submitErrorMessages: ["Bestelleinheit konnte nicht gelöscht werden"],
      };
    default:
      return state;
  }
}

export default reduceReducers(
  orderUnitsOverviewAppReducerFetch,
  orderUnitsOverviewAppReducerSubmit,
);
